import subDays from 'date-fns/esm/subDays';
import { createSelector } from 'reselect';
import { IState } from '..';
import { IBlobStorageConfig, IConfigApiResponse, ILogisticsConfig } from './configInterfaces';

export const getSalesDocumentsUrl = ({ config: { blobStorage } }: IState): string =>
  blobStorage ? `${blobStorage.baseUrl}${blobStorage.salesDocumentsContainer}` : '';

export const getCoOpRequestFileUrl = ({ config: { blobStorage } }: IState, coOpRequestId: number): string =>
  blobStorage ? `${blobStorage.baseUrl}${blobStorage.coOpFilesContainer}/${coOpRequestId}/` : '';

export const getNewDealerFileUrl = ({ config: { blobStorage } }: IState, businessEntityId: number): string =>
  blobStorage
    ? `${blobStorage.baseUrl}${blobStorage.businessEntityFilesContainer}/${businessEntityId}/NewDealerFiles`
    : '';

export const getSalesCallEditDays = ({ config: { sales } }: IState): number => (sales ? sales.salesCallEditDays : 0);

export const getSalesCallMinDate = (state: IState): Date => subDays(new Date(), getSalesCallEditDays(state));

export const getBlobContainer = createSelector(
  [
    (state: IState) => state.config.blobStorage,
    (_: IState, container: keyof Omit<IBlobStorageConfig, 'baseUrl'>) => container
  ],
  (blobStorage, container): string => (blobStorage ? blobStorage[container] : '')
);

export const getLogisticsConfig = createSelector(
  (state: IState) => state.config.logistics,
  (config): ILogisticsConfig =>
    config
      ? config
      : {
          applicableDeliveryModes: [],
          calendarVisibleWeeksAfterCurrent: 3,
          calendarVisibleWeeksPriorCurrent: 1,
          dashboardVisibleMonthsAfterCurrent: 2,
          dashboardVisibleWeeksAfterCurrent: 9,
          dashboardVisibleWeeksPriorCurrent: 1,
          notificationEmailAddress: ''
        }
);

export const isConfigLoading = createSelector(
  [(state: IState) => state.config.loading, (_: IState, type: keyof IConfigApiResponse) => type],
  (loading, type) => loading.includes(type)
);
